module.exports = __webpack_public_path__ + "static/img/8.8a0ebd1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/8.jpg
// module id = MNtS
// module chunks = 0